import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../constants/styles';
const { LOGIN_BG_COLOR, LOGIN_FORM_BG_COLOR, WHITE } = constants;

let styles = {
  base: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    backgroundColor: LOGIN_BG_COLOR
  },
  logo: {
    width: 160,
    margin: 30
  },
  outline: {
    display: 'flex',
    boxSizing: 'border-box',
    flexDirection: 'column',
    alignItems: 'center',
    width: 470,
    backgroundColor: LOGIN_FORM_BG_COLOR,
    borderRadius: 5,
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
    padding: '20px 50px',
    color: WHITE
  },
  msg:{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: WHITE,
    marginBottom: 30
  },
  link:{
    color: WHITE
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/containers/resetpassword/ResetPassword.styles.js